import { apiClient } from './api.client';
import { API_ENDPOINTS } from '../config/api.config';
import { FuelRecord, RecordFuelRequest } from '../types';

export const fuelService = {
  getAll: async (): Promise<FuelRecord[]> => {
    const response = await apiClient.get<FuelRecord[]>(API_ENDPOINTS.FUEL.BASE);
    return response.data;
  },

  getByTrip: async (tripId: number): Promise<FuelRecord[]> => {
    const response = await apiClient.get<FuelRecord[]>(API_ENDPOINTS.FUEL.BY_TRIP(tripId));
    return response.data;
  },

  getFlagged: async (): Promise<FuelRecord[]> => {
    const response = await apiClient.get<FuelRecord[]>(API_ENDPOINTS.FUEL.FLAGGED);
    return response.data;
  },

  record: async (data: RecordFuelRequest): Promise<FuelRecord> => {
    const response = await apiClient.post<FuelRecord>(API_ENDPOINTS.FUEL.BASE, data);
    return response.data;
  },
};
